import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MobileLayoutState } from "../../../types";


const initialState: MobileLayoutState = { 
    showTopBackNav: true
}

export const mobileLayouSlice = createSlice({
    name: 'mobileLayout',
    initialState,
    reducers: {
        setShowTopNav: (state, action) => {
            state.showTopBackNav = action.payload
        },

        setTopNavNameTitle: (state, action) => {
            state.topNavNameTitle = action.payload
        },

        clearTopNavNameTitle: (state) => {
            state.topNavNameTitle = undefined
        },
        
        resetState: () => initialState
    }
});


export const {resetState, setShowTopNav, clearTopNavNameTitle, setTopNavNameTitle} = mobileLayouSlice.actions;
export default mobileLayouSlice.reducer;   